"use client"
import { cache, useState } from "react"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  DotButton,
} from "@/modules/components/ui/carousel"
import Autoplay from "embla-carousel-autoplay"
import { BASE_URL, IMG_URL } from "@lib/config"
import ClientLink from "@modules/layout/components/client-link"
import { cn } from "@lib/util"

export default function Scorecardcarousel(props) {
  const { lng, data, needSplit, className } = props

  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      className={cn(
        "flex h-full w-full items-center justify-center",
        className
      )}
    >
      <Carousel
        opts={{ loop: true }}
        plugins={[
          Autoplay({
            delay: 2000,
          }),
        ]}
        scrollSnaps={Array.from(Array(data.length).keys())}
        className="relative flex h-full w-full transition-opacity duration-500"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <CarouselContent className="rounded-md">
          {data.map((item, index) => {
            return (
              <CarouselItem
                key={item.id}
                className={
                  needSplit ? "rounded-md px-2 lg:basis-1/3 lg:gap-4" : ""
                }
              >
                <div className="flex h-full flex-col rounded-md">
                  <div className="flex flex-col-reverse">
                    <div className="flex w-full flex-col items-start justify-start overflow-auto rounded-b p-5 py-7">
                      <div className="mb-5 font-bold text-2xl">{item.name}</div>
                      <div className="mb-5">{item.value}</div>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            )
          })}
        </CarouselContent>
        <DotButton className="bottom-2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
      </Carousel>
    </div>
  )
}
